import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "परिचय ", "link": "#" },
    { "name": "समय सारणी", "link": "#" },
    { "name": "उपलब्धियां", "link": "#" },
    { "name": "सम्पर्क", "link": "#" }
];

export default function EnglishHindiEnglishTranslationDiploma() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [content, setContent] = useState(departments[0].name);

    const handleItemClick = (index) => {
        setActiveIndex(index);
        setContent(departments[index].name);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle button for small screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"
                    } col-md-3`}
                style={{ backgroundColor: "white", overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3">अंग्रेजी-हिंदी-अंग्रेजी अनुवाद डिप्लोमा</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            onClick={() => handleItemClick(index)}
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer ${activeIndex === index ? "text-white" : "text-dark"
                                }`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeIndex === index ? "#77236b" : "white"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >
                <h5>{content}</h5>
            </main>
        </div>
    );
}
